import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getTokenData } from '../services/api';
import styled from 'styled-components';

const SkeletonContainer = styled.div`
  padding: 32px;
  max-width: 1400px;
  margin: 0 auto;
  background: var(--background-primary);
  min-height: 100vh;
`;

const SkeletonHeader = styled.div`
  margin-bottom: 40px;
`;

const SkeletonTitle = styled.div`
  height: 36px;
  width: 300px;
  background: linear-gradient(
    110deg,
    #ececec 8%,
    #f5f5f5 18%,
    #ececec 33%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s linear infinite;
  border-radius: 4px;
  margin-bottom: 12px;

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;

const SkeletonSubtitle = styled.div`
  height: 20px;
  width: 200px;
  background: linear-gradient(
    110deg,
    #ececec 8%,
    #f5f5f5 18%,
    #ececec 33%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s linear infinite;
  border-radius: 4px;
`;

const AdminSkeleton = () => (
  <SkeletonContainer>
    <SkeletonHeader>
      <SkeletonTitle />
      <SkeletonSubtitle />
    </SkeletonHeader>
  </SkeletonContainer>
);

const withAdminProtection = (WrappedComponent) => {
  return function WithAdminProtectionComponent(props) {
    const navigate = useNavigate();
    const [isAuthorized, setIsAuthorized] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      const checkAccess = () => {
        const tokenData = getTokenData();
        
        if (!tokenData || (tokenData.roleId !== 3 && tokenData.roleId !== 4)) {
          navigate('/', { replace: true });
          return;
        }
        
        setIsAuthorized(true);
        setLoading(false);
      };

      checkAccess();
    }, [navigate]);

    if (loading) {
      return <AdminSkeleton />;
    }

    return isAuthorized ? <WrappedComponent {...props} /> : null;
  };
};

export default withAdminProtection; 